import { ref } from "vue";

export const modalProps = {
  opener: {},
};

export const modalEmits = {
  closeModal: null,
};

export default function initModalFeature() {
  const dialog = ref(null);

  return { dialog };
}
